import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'app-maxion-goals-edit',
  templateUrl: './maxion-goals-edit.component.html',
  styleUrls: ['./maxion-goals-edit.component.css']
})
export class MaxionGoalsEditComponent implements OnInit {
  maxionGoalsEditForm!:FormGroup;
  submitted: any;
  token: any;
  casteData: any;
  id:any;
  maxianGoalData: any;
  image:any
  imageSrc:any
  fileName!: string;


  constructor(public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private activateroute: ActivatedRoute,
    private formBuilder : FormBuilder
    ) { }

  ngOnInit(): void {
    this.id = this.activateroute.snapshot.paramMap.get('id');
    this.maxionGoalsEditForm = this.formBuilder.group({
      name: ['',[Validators.required,this.prefrencesService.noSpacesValidator]],
      description:['',[Validators.required,this.prefrencesService.noSpacesValidator]],
      image:['']
    });
    this.geteditData()
  }

  get editForm() {return this.maxionGoalsEditForm.controls;}

  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.image = file;
      this.fileName =  file.name
      this.createImagePreview(file);
    }
  }

  createImagePreview(file: File) {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageSrc = event.target.result;
    };
    reader.readAsDataURL(file);
  }

  geteditData(){
    let obj = {
      id : this.id
    };
    this.token = localStorage['token'];
    this.prefrencesService.getMaxionGoalsDetails(obj, this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.maxianGoalData = res.data;
        this.maxionGoalsEditForm.patchValue({
          name:this.maxianGoalData.name,
          description:this.maxianGoalData.description
        });
        const imageName=this.maxianGoalData.image.split('/')
        this.fileName=imageName[imageName?.length - 1]
        this.image = this.maxianGoalData.image;
        this.maxionGoalsEditForm.value.image = this.image;
        if (this.image) {
          this.imageSrc = this.image;  // Assuming image is a URL or base64 data
        }
      }
      else{
        // this.toastr.success(res.message);
        alert(res.message);
      }
    });
  }

  onSubmit(){
    this.submitted = true;
    if (this.maxionGoalsEditForm.invalid) {
      return;
    }
    this.token = localStorage['token'];
   
    let formData = new FormData()
      formData.append('name',this.maxionGoalsEditForm.get('name')?.value)
      formData.append('image',this.image)
      formData.append('id',this.id)  
      formData.append('description',this.maxionGoalsEditForm.get('description')?.value)

    this.prefrencesService.editMaxionGoals(formData,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.toastr.success(res.message);
        this.router.navigate(['/maxion-goals-list']);
        this.maxionGoalsEditForm.reset();
        this.submitted = false;
      }
    });
  }
}
